import Vue from "vue";
import router from "../router";
import axios from "axios";

const host = process.env.VUE_APP_API_SERVER;

const routes = {
  resetPassword: host + "/pub/reset/password",
  recoveryPassword: host + "/pub/recover/password",
  profile: host + "/api/mobile/profile",
  logout: host + "/api/logout",
  changePassword: host + "/api/mobile/changePassword",
  reservations: host + "/api/mobile/reservations",
  layout: host + "/api/mobile/layout",
  typesRepetitions: host + "/api/mobile/typesRepetitions",
  typesWorkplaces: host + "/api/mobile/typesWorkplaces",
  areas: host + "/api/mobile/areas",
  locations: host + "/api/mobile/locations",
  workplaces: host + "/api/mobile/workplaces",
  workplace: host + "/api/mobile/workplace",
  reservation: host + "/api/mobile/reservation",
  check: host + "/api/check",
  checkIn: host + "/api/mobile/checkin",
  surveys: host + "/api/mobile/surveys",
  surveyAnswer: host + "/api/mobile/surveyAnswer",
  employees: host + "/api/mobile/employees",
  detailReservation: host + "/api/mobile/detailReservation",
  cart: host + "/api/mobile/cart",
  cartSuggestions: host + "/api/mobile/cart/suggestions",
  cartWorkplace: host + "/api/mobile/cart/workplace",
  cartReservation: host + "/api/mobile/cart/reservation",
  lastPublish: host + "/api/mobile/regulation/lastPublish",
  acceptRegulation: host + "/api/mobile/regulation/accept",
};

const modules = {
  usuarios: "USUARIOS",
};

export default {
  ws: function(method, name, data, type, file) {
    let isOnline = navigator.onLine;
    if (method === "get" && type == "url") {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get("jwt");
        let headers = {
          Authorization: "Bearer " + jwt,
        };
        return axios
          .get(routes[name] + "/" + data, { headers })
          .then((response) => {
            let res = response.data;
            return { ok: true, data: res.data };
          })
          .catch((error) => {
            if (!isOnline) {
              return { ok: false, code: "INTERNET_DISCONNECTED" };
            } else {
              return {
                ok: false,
                code: error.response.data.code,
                message: error.response.data.message,
              };
            }
          });
      } else {
        router.push("/login");
      }
    } else if (method === "get" && (type == "params" || type === undefined)) {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get("jwt");
        let headers = {
          Authorization: "Bearer " + jwt,
        };
        let params = "";
        for (let k in data) {
          if (k != "idestado_incan") {
            params += k + "=" + data[k] + "&";
          } else {
            params += k + "=" + data[k];
          }
        }
        params = params !== "" ? "?" + params : "";
        return axios
          .get(routes[name] + params, { headers })
          .then((response) => {
            let res = response.data;
            return { ok: true, data: res.data ? res.data : res };
          })
          .catch((error) => {
            if (!isOnline) {
              return { ok: false, code: "INTERNET_DISCONNECTED" };
            } else {
              return {
                ok: false,
                code: error.response.data.code,
                message: error.response.data.message,
              };
            }
          });
      } else {
        router.push("/login");
      }
    } else if (method === "post") {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get("jwt");
        let headers = {
          Authorization: "Bearer " + jwt,
        };
        return axios
          .post(routes[name], data, { headers })
          .then((response) => {
            let res = response.data;
            return { ok: true, data: res.data == undefined ? res : res.data };
          })
          .catch((error) => {
            if (!isOnline) {
              return { ok: false, code: "INTERNET_DISCONNECTED" };
            } else {
              return {
                ok: false,
                code: error.response.data.code,
                message: error.response.data.message,
              };
            }
          });
      } else {
        router.push("/login");
      }
    } else if (method === "put") {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get("jwt");
        let headers = {
          Authorization: "Bearer " + jwt,
        };
        return axios
          .put(routes[name], data, { headers })
          .then((response) => {
            let res = response.data;
            return { ok: true, data: res.data };
          })
          .catch((error) => {
            if (!isOnline) {
              return { ok: false, code: "INTERNET_DISCONNECTED" };
            } else {
              return {
                ok: false,
                code: error.response.data.code,
                message: error.response.data.message,
              };
            }
          });
      } else {
        router.push("/login");
      }
    } else if (method === "putFile") {
      if (Vue.prototype.$session.exists()) {
        let dataFile = new FormData();
        let fileInfo = file;
        dataFile.append("file", fileInfo);
        let jwt = Vue.prototype.$session.get("jwt");
        let headers = {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + jwt,
        };
        return axios
          .put(routes[name] + "/" + data + routes[type], dataFile, { headers })
          .then((response) => {
            let res = response.data;
            return { ok: true, data: res.data };
          })
          .catch((error) => {
            if (!isOnline) {
              return { ok: false, code: "INTERNET_DISCONNECTED" };
            } else {
              return {
                ok: false,
                code: error.response.data.code,
                message: error.response.data.message,
                line: error.response.data.data.line,
              };
            }
          });
      } else {
        router.push("/login");
      }
    } else if (method === "delete") {
      if (type == "url") {
        if (Vue.prototype.$session.exists()) {
          let jwt = Vue.prototype.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt,
          };
          return axios
            .delete(routes[name] + "/" + data, { headers })
            .then((response) => {
              let res = response.data;
              return { ok: true, data: res.data };
            })
            .catch((error) => {
              if (!isOnline) {
                return { ok: false, code: "INTERNET_DISCONNECTED" };
              } else {
                return {
                  ok: false,
                  code: error.response.data.code,
                  message: error.response.data.message,
                };
              }
            });
        } else {
          router.push("/login");
        }
      } else {
        if (Vue.prototype.$session.exists()) {
          let jwt = Vue.prototype.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt,
          };
          return axios
            .delete(routes[name], { headers, data })
            .then((response) => {
              let res = response.data;
              return { ok: true, data: res.data };
            })
            .catch((error) => {
              if (!isOnline) {
                return { ok: false, code: "INTERNET_DISCONNECTED" };
              } else {
                return {
                  ok: false,
                  code: error.response.data.code,
                  message: error.response.data.message,
                };
              }
            });
        } else {
          router.push("/login");
        }
      }
    }
  },
  check(option, path) {
    path = path.split("/");
    path = path[path.length - 1];
    let key = modules[path];
    if (option === 1) {
      key += "_LECTURA";
    } else if (option === 2) {
      key += "_ESCRITURA";
    } else if (option === 3) {
      key += "_ELIMINAR";
    } else {
      return false;
    }
    let per = Vue.prototype.$session.get("per");
    per = JSON.parse(atob(per));
    if (per.indexOf(key) >= 0) {
      return true;
    } else {
      return false;
    }
  },
  connection() {
    return navigator.onLine;
  },
  menu(path) {
    let ele = path.split("/").pop();
    if (ele in modules) {
      let key = modules[ele];
      key += "_LECTURA";
      let per = Vue.prototype.$session.get("per");
      per = JSON.parse(atob(per));
      if (per.indexOf(key) >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  routes,
};
